<style lang="less" scoped>
@import './confirm.less';
</style>
<template>
  <div style="width:1100px;margin:0 auto;overflow-x:auto;">
    <!--协议-->
    <div class="box-border">
      <p class="head-title pointer" style="color: #409eff;text-align: center"  @click="onToAgreement">《卡西欧隐私权政策》</p>
    </div>
    <!--收货信息开始-->
    <div class="box-border" style="margin-top:0;">
      <p class="head-title">收货信息</p>

      <div class="address-box">
        <ul>
          <li>
            <div class="left fl">
              <svg-icon class="address-location" icon-class="address" style="font-size:31px;" />
            </div>
            <div class="right" style="line-height:30px;">
              <el-radio-group v-model="addOrder.shippingType">
                <el-radio :label="item.value" v-for="item in $enums.shippingType.getList()">{{item.label}}</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li v-if="activity.region && activity.address">
            <div class="left fl">
              <span class="key-name">收货地址</span>
            </div>
            <div class="right fl">
              <div>{{ activity.region }}{{ activity.address }}</div>
              <el-input style="margin-top:10px" placeholder="请输入收货人信息" v-model="consigneeValue" />
              <el-input style="margin-top:10px" placeholder="请输入收货人手机号码" type="number" v-model="mobileValue" />
            </div>
          </li>
          <div style="display:block" v-else>

            <li style="margin-bottom:0;" v-if="(addOrder.shippingType == this.$enums.shippingType.EXPRESS)">
              <div class="left fl">
                <span class="key-name">收货地址</span>
              </div>
              <div class="right fl">
                <el-radio-group v-model="addressId" v-for="item in address" @change="getAddressInfo">
                  <el-radio :label="item.id" class="address-content">
                    <span class="address-info">{{item.consignee}}</span>
                    <span class="address-info">{{item.region}} {{item.address}}</span>
                    <span class="address-info">{{item.mobile}}</span>
                  </el-radio>
                </el-radio-group>
              </div>
            </li>

            <li v-if="(addOrder.shippingType == this.$enums.shippingType.EXPRESS && !activity.isAddressFixed)">
              <div class="left fl">&nbsp;</div>
              <div class="right">
                <el-button type="info" @click="dialogFormVisible = true" plain style="border-radius:0;">新增地址</el-button>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
    <!--收货信息结束-->

    <!--新增收货地址弹窗-->
    <el-dialog title="新增收货地址" :visible.sync="dialogFormVisible">
      <div id="addAddress">
        <div class="left fl">
          <el-form :rules="rules" :model="addAddress" ref="form">
            <ul>
              <li>
                <span class="key fl">所在地区：</span>
                <div class="area fl" style="width: 500px;">
                  <el-form-item prop="region">
                    <el-cascader style="width: 440px;" size="large" :options="regionList" v-model="regionOptions" @change="handleChange" ref="region"
                      :props="{label: 'regionName', value: 'regionName'}"></el-cascader>
                  </el-form-item>

                </div>
              </li>

              <li>
                <span class="key fl">详细地址：</span>
                <div class="area-detail fl">
                  <el-form-item prop="address">
                    <el-input style="width: 440px;" resize="none" type="textarea" :rows="3" placeholder="请输入详细地址信息，如街道、小区、门牌号等信息" v-model="addAddress.address"></el-input>
                  </el-form-item>
                </div>
              </li>

              <li style="margin-bottom: 0px;">
                <span class="key fl" style="letter-spacing: 4px;">收货人：</span>
                <div class="consign fl">
                  <el-form-item prop="consignee">
                    <el-input style="width: 160px;" placeholder="请输入姓名" v-model="addAddress.consignee"></el-input>

                  </el-form-item>
                </div>

                <span class="key fl">手机号码：</span>
                <div class="consign fl">
                  <el-form-item prop="mobile">
                    <el-input style="width: 160px;" placeholder="请输入11手机号码" v-model="addAddress.mobile"></el-input>
                  </el-form-item>

                </div>
              </li>

            </ul>
          </el-form>
        </div>
        <div class="right fl">
          <p class="set-default">
            <el-checkbox-group v-model="addAddress.isDefault">
              <el-checkbox label="1" style="font-size: 14px;">设为默认</el-checkbox>
            </el-checkbox-group>
          </p>
          <p class="submit">
            <span class="primary" @click="saveAddress">保存地址</span>
          </p>
        </div>
      </div>
    </el-dialog>
    <!--新增收货地址弹窗结束-->

    <!--支付方式开始-->
    <div class="box-border">
      <p class="head-title">支付方式</p>
      <div class="pay-type">
        <el-radio-group v-model="addOrder.payMethod">
          <el-radio :label="$enums.payments.ALIPAY_WEB"><img src="@/assets/payMethod/alipay.jpg"></el-radio>
          <el-radio :label="$enums.payments.WECHAT_SCAN"><img src="@/assets/payMethod/wechatPay.jpg"></el-radio>
        </el-radio-group>
      </div>
    </div>
    <!--支付方式结束-->

    <!--发票信息开始-->
    <div class="box-border">
      <p class="head-title">发票信息</p>
      <div class="invoice-info">
        <ul v-if="this.activity.invoiceForbidden">
          <li>
            <span class="left">发票类型：</span>
            <span class="right">个人</span>
          </li>
          <li>
            <span class="left">发票内容：</span>
            <span class="right">产品明细</span>
          </li>
          <li>
            <p class="desc">*关于内购发票：内购默认开具个人电子发票</p>
          </li>
        </ul>
        <ul v-else>
          <li>
            <span class="left">发票类型：</span>
            <span class="right">
              <el-radio-group v-model="invoiceRadio">
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">单位</el-radio>
              </el-radio-group>
            </span>
          </li>
          <div v-if="invoiceRadio === 1">
            <li>
              <span class="left">发票内容：</span>
              <span class="right">产品明细</span>
            </li>
          </div>
          <div v-if="invoiceRadio === 2">
            <li>
              <span class="left">单位名称：</span>
              <span class="right">
                <el-input style="width: 260px;" placeholder="请输入单位名称" v-model="invoiceName"></el-input>
              </span>
            </li>
            <li>
              <span class="left">税号：</span>
              <span class="right">
                <el-input style="width: 260px;" placeholder="请输入税号" v-model="invoiceNo"></el-input>
              </span>
            </li>
            <!-- <li>
              <span class="left">发票内容：</span>
              <span class="right">产品明细</span>
            </li> -->
          </div>
          <li>
            <p class="desc">*关于内购发票：内购默认开具个人电子发票</p>
          </li>
        </ul>
      </div>
    </div>
    <!--发票信息结束-->

    <!--商品清单开始-->
    <div class="product-list box-border" style="margin: 0;">
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column label="商品清单" width="630">
          <template slot-scope="scope">
            <div class="product-name product-image">
              <img :src="scope.row.image" alt="">
            </div>
            <div class="right product-name">
              <div class="product-string">
                {{ scope.row.productName }}
              </div>
              <div class="product-string sign">
                {{$enums.productMark.label(scope.row.mark)}}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="单价" width="240">
          <template slot-scope="scope">
            <span class="price">{{ scope.row.salePrice | price }}</span>
          </template>
        </el-table-column>

        <el-table-column label="数量">
          <template slot-scope="scope">
            <span class="number">{{scope.row.number}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="box-border order-basic-info">
      <div class="top">
        <p>
          <span class="fr value" :title="totalPrice | price">{{ totalPrice | price }}</span>
          <span class="fr name">商品金额：</span>
        </p>

        <p>
          <span class="fr value">{{ cartNum }}</span>
          <span class="fr name">总件数：</span>
        </p>

        <p>
          <span class="fr value">{{ plusFee | price}}</span>
          <span class="fr name">运费：</span>
        </p>

        <p>
          <span class="fr value">-{{ cartInfo.discountAmount | price}}</span>
          <span class="fr name">优惠：</span>
        </p>
      </div>

      <div class="bottom">
        <p>
          <span class="fr total-amount">{{ cartInfo.orderAmount | price }}</span>
          <span class="fr name">应付金额：</span>
        </p>

        <p v-if="(addOrder.shippingType == this.$enums.shippingType.EXPRESS)">
          <span class="fr value">
            {{addressInfo.region}}{{addressInfo.address}}
          </span>
          <span class="fr name">快递：</span>
        </p>

        <p>
          <!--<router-link :to="{ name: 'cart-index'}">-->
          <span class="fr pay-now" @click="submitOrder">去付款</span>
          <!--</router-link>-->
          <router-link :to="{ name: 'cart-index'}">
            <span class="fr back-cart">返回购物车</span>
          </router-link>
        </p>
      </div>

    </div>
    <!--商品清单结束-->

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'

export default {
  name: 'confirm',
  data() {
    const checkRegion = (_, value, callback) => {
      if (!this.addAddress.region)
        callback('请选择收货地址')
      callback()
    }
    const checkMobile = (_, value, callback) => {
      if (!this.addAddress.mobile) {
        callback('请输入手机号')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.addAddress.mobile)) {
        callback('手机号格式不正确')
        return
      }
      callback()
    }
    return {
      consigneeValue: '',
      mobileValue: '',
      rules: {
        address: [{ required: true, message: "请输入详情地址", trigger: "blur" }],
        consignee: [
          { required: true, message: "请输入收货人信息", trigger: "blur" }
        ],
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        region: [{ validator: checkRegion, trigger: "blur" }],
      },
      addressId: null,
      addressInfo: {},
      dialogFormVisible: false,
      options: regionData,
      regionOptions: [],
      plusFee: 0,
      addAddress: {
        consignee: '',
        mobile: '',
        region: '',
        address: '',
        isDefault: 0,
        memberId: 0,
      },
      addOrder: {
        memberId: 0,
        activityId: 0,
        payMethod: this.$enums.payments.ALIPAY_WEB,
        shippingType: this.$enums.shippingType.EXPRESS,
      },
      invoiceRadio: 1,
      regionList: [],
    };
  },
  methods: {
    handleChange(value) {
      this.$refs.form.clearValidate(['region'])
      this.addAddress.region = value.join(' ')
      // if (CodeToText[value[2]]) {
      //   this.addAddress.region = CodeToText[value[0]] + ' ' + CodeToText[value[1]] + ' ' + CodeToText[value[2]];
      // } else {
      //   this.addAddress.region = CodeToText[value[0]] + ' ' + CodeToText[value[1]];
      // }
    },
    createOrder() {
      this.addOrder.memberId = this.memberId;
      this.addOrder.activityId = this.activityId;
      this.addOrder.productAmount = this.totalPrice * 1;
      this.addOrder.shippingAmount = this.plusFee * 1;
      this.addOrder.orderAmount = this.totalPrice * 1 + this.plusFee * 1;
    },
    getAddressInfo() {
      this.addressInfo = this.address.find((item) => {
        if (this.addressId && (item.id == this.addressId)) {
          return true;
        } else if (!this.addressId && item.isDefault == 1) {
          return true;
        } else if (!this.addressId) {
          return true;
        }
        return false;
      });
      if (!this.addressId) {
        this.addressId = this.addressInfo.id;
      }
    },
    async saveAddress() {
      this.$refs.form.validate(async (value) => {
        if (value) {
          this.addAddress.memberId = this.memberId;
          const result = await this.$store.dispatch('address/create', this.addAddress);
          this.addressId = result.document.id;
          this.getAddress();
          this.getAddressInfo();
          this.dialogFormVisible = false;
        }
      })

    },
    async getAddress() {
      await this.$store.dispatch('address/collection', { sorts: { isDefault: 'DESC', } , query: { activityId: this.activityId } , all: true  });
      if (this.address.length > 0) {
        this.getAddressInfo();
      }
    },
    async submitOrder() {
      if (this.activity.region && this.activity.address) {
        if (!this.consigneeValue) {
          this.$message.warning('请输入收货人信息')
          return
        }
        if (!this.mobileValue) {
          this.$message.warning('请输入收货人手机号码')
          return
        }
        if (!/^1[3456789]\d{9}$/.test(this.mobileValue)) {
          this.$message.warning('请输入正确的手机号码')
          return
        }
      } else if (!this.addressId) {
        this.$message.warning('请选择收货地址后再提交')
        return
      }
      if (!this.invoiceName && this.invoiceRadio === 2) {
        this.$message.warning('请输入单位名称')
        return
      }
      if (!this.invoiceNo && this.invoiceRadio === 2) {
        this.$message.warning('请输入税号')
        return
      }
      //判断收货方式
      if (this.addOrder.shippingType == this.$enums.shippingType.EXPRESS) {
        if (this.activity.region && this.activity.address) {
          this.addOrder.consignee = this.consigneeValue;
          this.addOrder.mobile = this.mobileValue;
          this.addOrder.region = this.activity.region;
          this.addOrder.address = this.activity.address;
        } else {
          this.addOrder.consignee = this.addressInfo.consignee;
          this.addOrder.mobile = this.addressInfo.mobile;
          this.addOrder.region = this.addressInfo.region;
          this.addOrder.address = this.addressInfo.address;
        }
      }
      const orderProducts = []
      this.tableData.map(item => {
        orderProducts.push({
          activityProductId: item.activityProductId,
          discountAmount: item.discountAmount,
          image: item.image,
          mark: item.mark,
          number: item.number,
          productName: item.productName,
          productSpecId: item.productSpecId,
          realPrice: item.realPrice,
          salePrice: item.salePrice,
          sku: item.sku
        })
      })
      this.addOrder.orderProducts = orderProducts
      if (this.invoiceRadio === 2) {
        this.addOrder.invoiceName = this.invoiceName
        this.addOrder.invoiceNo = this.invoiceNo
      }
      await this.$store.dispatch('orders/create', this.addOrder).then((result) => {
        if (result.document.id) {
          this.$store.dispatch('cart/clear');
          this.$router.push({ name: 'pay-index', params: { id: result.document.id } });
        }
      });
    },
    onToAgreement() {
      this.$router.push({ name: 'agreement' , params: { name: 'privacy' } });
    },
  },
  async mounted() {
    this.plusFee = this.activity.deliveryConfigs.express.plusFee ? this.activity.deliveryConfigs.express.plusFee : 0;
    this.getAddress();
    this.createOrder();
    this.regionList = await this.$store.dispatch('address/getRegion')
    if (this.activity.region && this.activity.address) {
      const data = await this.$store.dispatch('address/getConsignee')
      if (data.consignee) {
        this.consigneeValue = data.consignee
      }

      if (data.mobile) {
        this.mobileValue = data.mobile
      }
    }
  },
  computed: {
    ...mapState('cart', {
      tableData: state => state.cart,
      cartInfo: state => state.cartInfo
    }),
    ...mapState('activity', {
      activity: state => state.activity,
      activityId: state => state.activityId,
    }),
    ...mapState('address', {
      address: state => state.collection.collection,
    }),
    ...mapState('auth', {
      memberId: state => state.currentUser.id
    }),
    ...mapGetters('cart', {
      cartNum: 'cartNum',
      totalPrice: 'totalPrice',
    }),
  },
};
</script>


